// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "decco/src/Decco.bs.mjs";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "value",
                Decco.floatToJson(v.value)
              ],
              [
                "currency",
                Decco.stringToJson(v.currency)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var value = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
  if (value.TAG === /* Ok */0) {
    var currency = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "currency"), null));
    if (currency.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                value: value._0,
                currency: currency._0
              }
            };
    }
    var e = currency._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".currency" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = value._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".value" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var codec = [
  t_encode,
  t_decode
];

var toJson = t_encode;

var fromJson = t_decode;

export {
  t_encode ,
  t_decode ,
  codec ,
  toJson ,
  fromJson ,
}
/* No side effect */
